import { createRoot } from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import { ContentEditor } from "./content-management/ContentEditor";
import { customTheme } from "./theme";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PageConfigProvider } from "./components/PageConfigProvider";
/**
 * Full page render
 */
// @ts-ignore
const root = document.getElementById("echargeroot");
if (root) {
    const reactDom = createRoot(root);
    reactDom.render(React.createElement(ChakraProvider, { theme: customTheme },
        React.createElement(PageConfigProvider, null,
            React.createElement(Header, null),
            React.createElement(ContentEditor, null),
            React.createElement(Footer, null))));
}
/**
 * Single snippet render
 */
// @ts-ignore
const snippetRoot = document.getElementById("echargesnippet");
if (snippetRoot) {
    const reactDom = createRoot(snippetRoot);
    reactDom.render(React.createElement(ChakraProvider, { theme: customTheme },
        React.createElement(PageConfigProvider, null,
            React.createElement(ContentEditor, { allowedTypes: ["stack", "image", "text", "title", "box", "form", "snippet", "faq", "container", "hero", "highlight"] }))));
}
